export interface State {
  processId: string;
  state: Label;
  remark: Remark;
}

export enum Remark {
  Empty = "",
  Canceled = "canceled",
}

export enum Label {
  Running = "running",
  Archived = "archived",
  Done = "done",
}
